import * as en from './en.json';
import * as vi from './vi.json';
import * as zhCN from './zh.json';
import * as ja from './ja.json';
import * as es from './es.json';
import * as it from './it.json';
import * as ko from './ko.json';
import * as de from './de.json';
import * as fr from './fr.json';

export default { en, vi, zhCN, ja, es, it, ko, de, fr };
